import * as React from 'react'

export const SortButton = (props) => {

  const {title, onClick, sortOrder, classNames} = props
  return (
    <div onClick={onClick} style={{cursor: 'pointer'}} className={classNames ? classNames : ""}>
      <span style={{marginRight: '5px'}}>{title}</span>
      <span style={{width: '13.5px'}} className="d-flex">
        {sortOrder ? (sortOrder === 'ASC' ?
          <span className={'d-flex align-self-center far fa-chevron-up'}/> :
          <span className={'d-flex align-self-center far fa-chevron-down'}/> ) : ""
        }
      </span>
    </div>
  )

}